<template>
  <div class="drawer-filter">
    <a class="filter-trigger" @click="toggleDropDown">
      <i class="fa fa-filter fa-2x"></i>
      <span v-if="activeFilterCount > 0" class="filter-badge">{{ activeFilterCount }}</span>
    </a>
    <div v-if="isOpen" class="filter-overlay" @click="closeDropDown"></div>
    <div class="filter-panel" :class="{ open: isOpen }">
      <div class="filter-panel-header">
        <span>{{ $t("shippingPlan.filterTitle") }}<template v-if="activeFilterCount > 0"> ({{ activeFilterCount }})</template></span>
        <md-button class="md-simple md-just-icon md-round" @click="closeDropDown"><md-icon>clear</md-icon></md-button>
      </div>
      <div class="filter-panel-body">
        <div class="filter-section">
          <div class="filter-section-title">{{ $t("shippingPlan.filterSections.status") }}</div>
          <md-field md-clearable>
            <label for="filter-recordStatus">{{ $t("shippingPlan.recordStatus") }}</label>
            <md-select v-model="filter.recordStatusId" name="filter-recordStatus" id="filter-recordStatus">
              <md-option :key="i.id" v-for="i in recordStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.recordStatuses", i.name) }}</md-option>
            </md-select>
          </md-field>
          <md-field md-clearable>
            <label for="filter-containerBookingStatus">{{ $t("shippingPlan.containerBookingStatus") }}</label>
            <md-select v-model="filter.containerBookingStatus" name="filter-containerBookingStatus" id="filter-containerBookingStatus">
              <md-option value="pending">{{ $t("shippingPlan.bookingStatus.pending") }}</md-option>
              <md-option value="requested">{{ $t("shippingPlan.bookingStatus.requested") }}</md-option>
              <md-option value="confirmed">{{ $t("shippingPlan.bookingStatus.confirmed") }}</md-option>
            </md-select>
          </md-field>
          <div class="wrap-v-select filter-record-tags">
            <label class="v-select-label">{{ $t("shippingPlan.filterByTag") }}</label>
            <record-tag-select v-model="tags" />
          </div>
        </div>

        <div class="filter-section">
          <div class="filter-section-title">{{ $t("shippingPlan.filterSections.order") }}</div>
          <div class="filter-supplier">
            <label class="filter-supplier-label">{{ $t("shippingPlan.supplierName") }}</label>
            <v-select
              class="custom-select"
              label="name"
              append-to-body :calculate-position="alignDropdown"
              :options="supplierNameOptions"
              :filter="filterSupplier"
              :value="selectedSupplier"
              @input="onSupplierFilterInput"
              :placeholder="$t('shippingPlan.supplierName')"
            ></v-select>
          </div>
          <div class="filter-row">
            <md-field md-clearable>
              <label>{{ $t("shippingPlan.hasProduct") }}?</label>
              <md-select v-model="filter.hasProduct" name="filter-hasProduct" id="filter-hasProduct">
                <md-option value="true">{{ $t("shippingPlan.yes") }}</md-option>
                <md-option value="false">{{ $t("shippingPlan.no") }}</md-option>
              </md-select>
            </md-field>
            <md-field md-clearable>
              <label>{{ $t("shippingPlan.hasShipmentNote") }}?</label>
              <md-select v-model="filter.hasShipmentNote" name="filter-shipmentNote" id="filter-shipmentNote">
                <md-option value="true">{{ $t("shippingPlan.yes") }}</md-option>
                <md-option value="false">{{ $t("shippingPlan.no") }}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>

        <div class="filter-section">
          <div class="filter-section-title">{{ $t("shippingPlan.filterSections.container") }}</div>
          <div class="filter-row">
            <md-field md-clearable>
              <label for="filter-containerSize">{{ $t("shippingPlan.containerSize") }}</label>
              <md-select v-model="filter.containerSizeId" name="filter-containerSize" id="filter-containerSize">
                <md-option :key="i.id" v-for="i in containerSizeOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.containerSizes", i.name) }}</md-option>
              </md-select>
            </md-field>
            <md-field md-clearable>
              <label for="filter-containerArrivalPlace">{{ $t("shippingPlan.containerArrivalPlace") }}</label>
              <md-select v-model="filter.containerArrivalPlaceId" name="filter-containerArrivalPlace" id="filter-containerArrivalPlace">
                <md-option :key="i.id" v-for="i in containerArrivalPlaceOptions" :value="i.id">{{ i.name }}</md-option>
              </md-select>
            </md-field>
          </div>
          <md-field md-clearable>
            <label for="filter-carrierName">{{ $t("shippingPlan.carrierName") }}</label>
            <md-select v-model="filter.carrierNameId" name="filter-carrierName" id="filter-carrierName">
              <md-option :key="i.id" v-for="i in carrierNameOptions" :value="i.id">{{ i.name }}</md-option>
            </md-select>
          </md-field>
          <div class="filter-date-label">{{ $t("shippingPlan.containerArrivalDate") }}</div>
          <div class="filter-row">
            <date-picker v-model="containerArrivalDateFromInput" format="YYYY-MM-DD" type="date" :placeholder="$t('shippingPlan.from')"></date-picker>
            <date-picker v-model="containerArrivalDateToInput" format="YYYY-MM-DD" type="date" :placeholder="$t('shippingPlan.to')"></date-picker>
          </div>
        </div>

        <div class="filter-section">
          <div class="filter-section-title">{{ $t("shippingPlan.filterSections.payment") }}</div>
          <md-field md-clearable>
            <label for="filter-paymentStatus">{{ $t("shippingPlan.paymentStatus") }}</label>
            <md-select v-model="filter.paymentStatusId" name="filter-paymentStatus" id="filter-paymentStatus">
              <md-option :key="i.id" v-for="i in paymentStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.paymentStatuses", i.name) }}</md-option>
            </md-select>
          </md-field>
          <div class="filter-row">
            <md-field md-clearable>
              <label for="filter-shipmentPaidStatus">{{ $t("shippingPlan.shipmentPaidStatus") }}</label>
              <md-select v-model="filter.shipmentPaidStatusId" name="filter-shipmentPaidStatus" id="filter-shipmentPaidStatus">
                <md-option :key="i.id" v-for="i in shipmentPaidStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.shipmentPaidStatuses", i.name) }}</md-option>
              </md-select>
            </md-field>
            <md-field md-clearable>
              <label for="filter-customsPaidStatus">{{ $t("shippingPlan.customsPaidStatus") }}</label>
              <md-select v-model="filter.customsPaidStatusId" name="filter-customsPaidStatus" id="filter-customsPaidStatus">
                <md-option :key="i.id" v-for="i in customsPaidStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.customsPaidStatuses", i.name) }}</md-option>
              </md-select>
            </md-field>
          </div>
          <md-field md-clearable>
            <label for="filter-accountingStatus">{{ $t("shippingPlan.accountingStatus") }}</label>
            <md-select v-model="filter.accountingStatusId" name="filter-accountingStatus" id="filter-accountingStatus">
              <md-option :key="i.id" v-for="i in accountingStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.accountingStatuses", i.name) }}</md-option>
            </md-select>
          </md-field>
          <div class="filter-date-label">{{ $t("shippingPlan.accountingStatusDate") }}</div>
          <div class="filter-row">
            <date-picker v-model="accountingStatusDateFromInput" format="YYYY-MM-DD" type="date" :placeholder="$t('shippingPlan.from')"></date-picker>
            <date-picker v-model="accountingStatusDateToInput" format="YYYY-MM-DD" type="date" :placeholder="$t('shippingPlan.to')"></date-picker>
          </div>
        </div>

        <div class="filter-section">
          <div class="filter-section-title">{{ $t("shippingPlan.filterSections.china") }}</div>
          <div class="filter-row">
            <md-field md-clearable>
              <label for="filter-chinaStatus">{{ $t("shippingPlan.chinaStatus") }}</label>
              <md-select v-model="filter.chinaStatusId" name="filter-chinaStatus" id="filter-chinaStatus">
                <md-option :key="i.id" v-for="i in chinaStatusOptions" :value="i.id">{{ getI18N("shippingPlan.statuses.chinaStatuses", i.name) }}</md-option>
              </md-select>
            </md-field>
            <md-field md-clearable>
              <label for="filter-chinaUser">{{ $t("shippingPlan.chinaUser") }}</label>
              <md-select v-model="filter.chinaUser" name="filter-chinaUser" id="filter-chinaUser">
                <md-option :key="i.id" v-for="i in chinaUserOptions" :value="i.id">{{ i.name }}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="filter-row">
            <md-field md-clearable>
              <label for="filter-mtcStatus">{{ $t("shippingPlan.mtcStatus") }}</label>
              <md-select v-model="filter.mtcStatus" name="filter-mtcStatus" id="filter-mtcStatus">
                <md-option value="pending">{{ $t("shippingPlan.documentStatuses.pending") }}</md-option>
                <md-option value="requested">{{ $t("shippingPlan.documentStatuses.requested") }}</md-option>
                <md-option value="received">{{ $t("shippingPlan.documentStatuses.received") }}</md-option>
                <md-option value="forwarded">{{ $t("shippingPlan.documentStatuses.forwarded") }}</md-option>
                <md-option value="not_needed">{{ $t("shippingPlan.documentStatuses.not_needed") }}</md-option>
              </md-select>
            </md-field>
            <md-field md-clearable>
              <label for="filter-coStatus">{{ $t("shippingPlan.coStatus") }}</label>
              <md-select v-model="filter.coStatus" name="filter-coStatus" id="filter-coStatus">
                <md-option value="pending">{{ $t("shippingPlan.documentStatuses.pending") }}</md-option>
                <md-option value="requested">{{ $t("shippingPlan.documentStatuses.requested") }}</md-option>
                <md-option value="received">{{ $t("shippingPlan.documentStatuses.received") }}</md-option>
                <md-option value="forwarded">{{ $t("shippingPlan.documentStatuses.forwarded") }}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>

        <div class="filter-section">
          <div class="filter-section-title">{{ $t("shippingPlan.filterSections.documents") }}</div>
          <md-field md-clearable>
            <label>{{ $t("shippingPlan.hasDocument") }}?</label>
            <md-select v-model="filter.hasDocument" name="filter-hasDoc" id="filter-hasDoc">
              <md-option value="true">{{ $t("shippingPlan.yes") }}</md-option>
              <md-option value="false">{{ $t("shippingPlan.no") }}</md-option>
            </md-select>
          </md-field>
          <md-field>
            <label for="filter-uncheckedDocs">{{ $t("shippingPlan.uncheckedDocuments") }}</label>
            <md-select v-model="uncheckedDocs" multiple name="filter-uncheckedDocs" id="filter-uncheckedDocs">
              <md-option value="pi">PI</md-option>
              <md-option value="ci">CI</md-option>
              <md-option value="pl">PL</md-option>
            </md-select>
          </md-field>
          <div class="filter-row">
            <md-field md-clearable>
              <label>{{ $t("shippingPlan.wmsBookedShort") }}?</label>
              <md-select v-model="filter.wmsGebucht" name="filter-wmsGebucht" id="filter-wmsGebucht">
                <md-option value="true">{{ $t("shippingPlan.yes") }}</md-option>
                <md-option value="false">{{ $t("shippingPlan.no") }}</md-option>
              </md-select>
            </md-field>
            <md-field md-clearable>
              <label>{{ $t("shippingPlan.afterbuyBookedShort") }}?</label>
              <md-select v-model="filter.afterbuyGebucht" name="filter-afterbuyGebucht" id="filter-afterbuyGebucht">
                <md-option value="true">{{ $t("shippingPlan.yes") }}</md-option>
                <md-option value="false">{{ $t("shippingPlan.no") }}</md-option>
              </md-select>
            </md-field>
          </div>
          <md-field md-clearable>
            <label>{{ $t("shippingPlan.productDataSentShort") }}?</label>
            <md-select v-model="filter.productDataSent" name="filter-productDataSent" id="filter-productDataSent">
              <md-option value="true">{{ $t("shippingPlan.yes") }}</md-option>
              <md-option value="false">{{ $t("shippingPlan.no") }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <div class="filter-panel-footer">
        <md-button class="md-secondary" @click="clearFilters">{{ $t("shippingPlan.clear") }}</md-button>
        <md-button class="md-success" @click="applyFilters">{{ $t("shippingPlan.apply") }}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import { alignDropdown } from "@/mixins/dropdownPosition";
import { DrawerScrollLockMixin } from "@/mixins/drawerScrollLock";

import DatePicker from "vue2-datepicker";
import { normalizeStatusName } from "../../mixins/formats";
import RecordTagSelect from "./RecordTagSelect.vue";

export default {
  props: {},
  mixins: [DrawerScrollLockMixin],
  components: {
    DatePicker,
    RecordTagSelect,
  },
  data() {
    return {
      isOpen: false,
      tags: [],
      uncheckedDocs: [],
      containerArrivalDateFromInput: null,
      containerArrivalDateToInput: null,
      accountingStatusDateFromInput: null,
      accountingStatusDateToInput: null,
      filter: {
        shipmentRecordId: null,
        recordStatusId: null,
        recordTags: null,
        hasShipmentNote: null,
        hasProduct: null,
        hasDocument: null,
        uncheckedDocuments: null,
        supplierOrderId: null,
        supplierNameId: null,
        containerId: null,
        containerSizeId: null,
        containerArrivalDateFrom: null,
        containerArrivalDateTo: null,
        containerArrivalPlaceId: null,
        carrierNameId: null,
        paymentStatusId: null,
        shipmentPaidStatusId: null,
        customsPaidStatusId: null,
        chinaStatusId: null,
        chinaUser: null,
        productDataSent: null,
        wmsGebucht: null,
        afterbuyGebucht: null,
        containerBookingStatus: null,
        mtcStatus: null,
        coStatus: null,
        accountingStatusId: null,
        accountingStatusDateFrom: null,
        accountingStatusDateTo: null,
      },
    };
  },
  computed: {
    recordStatusOptions() {
      return this.$store.state.shippingData.recordStatuses || [];
    },
    recordTagOptions() {
      return this.$store.state.shippingData.recordTags || [];
    },
    supplierNameOptions() {
      return this.$store.state.shippingData.supplierNames || [];
    },
    selectedSupplier() {
      return this.supplierNameOptions.find((s) => s.id === this.filter.supplierNameId) || null;
    },
    containerSizeOptions() {
      return this.$store.state.shippingData.containerSizes || [];
    },
    containerArrivalPlaceOptions() {
      return this.$store.state.shippingData.containerArrivalPlaces || [];
    },
    carrierNameOptions() {
      return this.$store.state.shippingData.carrierNames || [];
    },
    paymentStatusOptions() {
      return this.$store.state.shippingData.paymentStatuses || [];
    },
    shipmentPaidStatusOptions() {
      return this.$store.state.shippingData.shipmentPaidStatuses || [];
    },
    customsPaidStatusOptions() {
      return this.$store.state.shippingData.customsPaidStatuses || [];
    },
    chinaStatusOptions() {
      return this.$store.state.shippingData.chinaStatuses || [];
    },
    linkedProductOptions() {
      return this.$store.state.shippingData.linkedProducts || [];
    },
    chinaUserOptions() {
      return this.$store.state.shippingData.chinaUsers || [];
    },
    accountingStatusOptions() {
      return this.$store.state.shippingData.accountingStatuses || [];
    },
    activeFilterCount() {
      const dateKeys = ["recordTags", "uncheckedDocuments", "containerArrivalDateFrom", "containerArrivalDateTo", "accountingStatusDateFrom", "accountingStatusDateTo"];
      let count = Object.entries(this.filter).filter(([k, v]) => !dateKeys.includes(k) && v !== null && v !== "").length;
      if (this.tags.length) count += 1;
      if (this.uncheckedDocs.length) count += 1;
      if (this.containerArrivalDateFromInput || this.containerArrivalDateToInput) count += 1;
      if (this.accountingStatusDateFromInput || this.accountingStatusDateToInput) count += 1;
      return count;
    },
  },
  mounted() {
    document.addEventListener("click", this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
  },
  methods: {
    alignDropdown,
    toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown() {
      this.isOpen = false;
    },
    clearFilters() {
      Object.keys(this.filter).forEach((key) => {
        this.filter[key] = null;
      });
      this.tags = [];
      this.uncheckedDocs = [];
      this.containerArrivalDateFromInput = null;
      this.containerArrivalDateToInput = null;
      this.accountingStatusDateFromInput = null;
      this.accountingStatusDateToInput = null;
    },
    // Vom Lieferplan aufgerufen: Klick auf den Lieferantennamen filtert auf diesen Lieferanten
    // (Trello 20.08., wie im Bestellwesen). Archiv-Schalter bleibt unangetastet.
    setSupplier(supplierNameId) {
      this.filter.supplierNameId = supplierNameId || null;
      this.applyFilters();
    },
    applyFilters() {
      this.filter.accountingStatusDateFrom = this.accountingStatusDateFromInput ? format(this.accountingStatusDateFromInput, "yyyy-MM-dd") : null;
      this.filter.accountingStatusDateTo = this.accountingStatusDateToInput ? format(this.accountingStatusDateToInput, "yyyy-MM-dd") : null;
      this.filter.containerArrivalDateFrom = this.containerArrivalDateFromInput ? format(this.containerArrivalDateFromInput, "yyyy-MM-dd") : null;
      this.filter.containerArrivalDateTo = this.containerArrivalDateToInput ? format(this.containerArrivalDateToInput, "yyyy-MM-dd") : null;
      this.filter.recordTags = this.tags.length ? this.tags.join(",") : null;
      this.filter.uncheckedDocuments = this.uncheckedDocs.length ? this.uncheckedDocs.join(",") : null;
      this.$emit("apply-filters", this.filter);
      this.closeDropDown();
    },
    onClickOutside(e) {
      const inSelectMenu = e.target.closest && e.target.closest(".md-menu-content");
      if (this.isOpen && !inSelectMenu && document.body.contains(e.target) && !this.$el.contains(e.target)) {
        this.closeDropDown();
      }
    },
    onSupplierFilterInput(val) {
      this.filter.supplierNameId = val ? val.id : null;
    },
    filterSupplier(options, search) {
      const s = (search || "").toLowerCase().trim();
      if (!s) return options;
      return options.filter((o) => [o.name, o.nameFull, o.creditor, o.bankId].some((v) => v != null && String(v).toLowerCase().includes(s)));
    },
    getI18N(prefix, statusName) {
      return this.$t(`${prefix}.${normalizeStatusName(statusName)}`);
    },
  },
};
</script>
<style>
.drawer-filter .filter-trigger {
  position: fixed;
  top: 210px;
  right: 0;
  z-index: 1031;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid #bbb;
  border-right: 0 none;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: block;
}
.drawer-filter .filter-trigger i.fa {
  display: block;
  padding: 15px;
  color: #ffffff !important;
}
.drawer-filter .filter-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  background: #f44336;
  color: #fff;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  font-weight: 600;
}
.drawer-filter .filter-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1032;
}
.drawer-filter .filter-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 420px;
  max-width: 95vw;
  background: #fff;
  z-index: 1033;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 18px rgba(0, 0, 0, 0.25);
  transform: translateX(100%);
  transition: transform 0.25s ease;
  visibility: hidden;
}
.drawer-filter .filter-panel.open {
  transform: translateX(0);
  visibility: visible;
}
.drawer-filter .filter-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 10px 20px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 16px;
  font-weight: 500;
  flex: 0 0 auto;
}
.drawer-filter .filter-panel-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 4px 20px 16px 20px;
  text-align: left;
}
.drawer-filter .filter-panel-footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
}
.drawer-filter .filter-section {
  margin-top: 14px;
}
.drawer-filter .filter-section-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9e9e9e;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
  margin-bottom: 4px;
}
.drawer-filter .filter-row {
  display: flex;
  gap: 14px;
}
.drawer-filter .filter-row > * {
  flex: 1;
  min-width: 0;
}
.drawer-filter .filter-row .mx-datepicker {
  width: 100%;
  margin: 6px 0 10px 0;
}
.drawer-filter .filter-date-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 6px;
}
.drawer-filter .md-field {
  margin: 2px 0 14px 0;
  min-height: 42px;
}
.drawer-filter .filter-record-tags {
  margin: 8px 0 14px 0;
}
.drawer-filter .filter-supplier {
  margin: 2px 0 14px 0;
}
.drawer-filter .filter-supplier-label {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 2px;
}
</style>
